import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-5 px-3 mt-0 mb-10" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col gap-3 bg-white rounded-md shadow-md border-b-4 border-h-primary-700 p-5 py-3"
}
const _hoisted_3 = { class: "font-bold text-neutral-800 text-[16px]" }
const _hoisted_4 = { class: "flex flex-wrap items-center text-h-primary-500 gap-5" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "text-[12px]" }
const _hoisted_7 = {
  key: 1,
  class: "bg-red-50"
}
const _hoisted_8 = { class: "font-bold text-neutral-800 text-[16px]" }
const _hoisted_9 = { class: "h-96 overflow-auto scroll-style" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "border-b flex items-center w-full gap-3 hover:bg-h-secondary-50 transition-all cursor-pointer" }
const _hoisted_12 = { class: "flex items-center gap-1 p-3 font-bold" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, "-", -1)
const _hoisted_14 = { class: "w-full py-5 px-2 font-[600] text-lg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_Crawler = _resolveComponent("Crawler")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      (_ctx.keys && _ctx.keys.length !== 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("labels.generic", {
            pt: "Clique nas palavras-chave e veja vídeos relacionados",
            en: "Click on keywords and watch related videos",
          })), 1),
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.keys, (item, i) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: i,
                  class: "bg-h-primary-200 rounded-[1.2rem] px-2 py-1 border text-sm md:text-sm font-[600] transition-all hover:scale-95 hover:opacity-80",
                  onClick: ($event: any) => (_ctx.openCrawler(item.keyword))
                }, [
                  _createElementVNode("p", _hoisted_6, _toDisplayString(item.keyword), 1)
                ], 8, _hoisted_5))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.transcripts && _ctx.transcripts.length !== 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_Accordion, {
              class: "accordion-crawler-custom",
              lazy: true,
              activeIndex: 0
            }, {
              default: _withCtx(() => [
                _createVNode(_component_AccordionTab, null, {
                  header: _withCtx(() => [
                    _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("labels.generic", {
                  pt: "Ver transcrição do vídeo",
                  en: "View video transcript",
                })), 1)
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_9, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transcripts, (item, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: i,
                          onClick: _withModifiers(($event: any) => (_ctx.onClickDuration(item.startTime)), ["prevent"])
                        }, [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("p", null, _toDisplayString(_ctx.duration(item.startTime)), 1),
                              _hoisted_13,
                              _createElementVNode("p", null, _toDisplayString(_ctx.duration(item.endTime)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_14, [
                              _createElementVNode("p", null, _toDisplayString(item.transcript), 1)
                            ])
                          ])
                        ], 8, _hoisted_10))
                      }), 128))
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showModal)
      ? (_openBlock(), _createBlock(_component_Crawler, {
          key: 0,
          onOnClose: _ctx.onCloseCrawler,
          keyword: _ctx.keyword,
          transcriptId: _ctx.transcriptId
        }, null, 8, ["onOnClose", "keyword", "transcriptId"]))
      : _createCommentVNode("", true)
  ], 64))
}